import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\common\\globals\\NavigationMenuInner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\2406mem\\components\\ietls\\IeltsDetails.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\2406mem\\components\\ietls\\IeltsSectionRenderer.jsx");
